var map = {
	"./config.awstest.json": "./src/config/config.awstest.json",
	"./config.current.json": "./src/config/config.current.json",
	"./config.dev.json": "./src/config/config.dev.json",
	"./config.prod.json": "./src/config/config.prod.json",
	"./config.test.json": "./src/config/config.test.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config sync recursive ^\\.\\/config\\..*\\.json$";